import { TriangleAlert } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function ErrorState () {
  const { t } = useTranslation()
  return (
    <div className='w-full h-full flex min-h-32 justify-center items-center border-2 border-dashed rounded-2xl border-red-200 gap-3 bg-red-50 opacity-70'>
      <TriangleAlert className='text-red-500' />
      <h2 className="text-red-500">{t('common:Error fetching data')}</h2>
    </div>
  )
}
